import {
  CheckOutlined,
  CloseOutlined,
  EditOutlined,
  QuestionCircleOutlined,
  WarningOutlined,
  SyncOutlined,
} from "@ant-design/icons";
import {
  Button,
  Rate,
  Drawer,
  Image,
  Avatar,
  Form,
  Select,
  Alert,
  Popconfirm,
  Space,
} from "antd";
import axios from "axios";
import moment from "moment";
import PropTypes from "prop-types";
import React, {
  ReactElement,
  useCallback,
  useEffect,
  useRef,
  useState,
} from "react";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { authenticateToken } from "../../../utils/auth";
import { responseNotification } from "../../../utils/notify";
import { useHistory, useParams } from "react-router";
import { debounce } from "lodash";
import ShopLayout from "../Layout";
import AddShop from "../AddShop";

import ShopHeader from "../Layout/topHeader";
import { useDispatch } from "react-redux";
import { SET_SHOP_INFO } from "../../../redux/auth/authType";
import MapBox from "../../common/MapBox";
const { Option } = Select;

const ShopDetails = (): ReactElement => {
  const [type, setType] = useState("JC_MART");
  const [visible, setVisible] = useState(undefined);
  const [visibleDrawer, setVisibleDrawer] = useState(undefined);

  const route = useParams();
  const history = useHistory();
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const [selectedShopForEdit, setSelectedShopForEdit] = useState(undefined);
  const [shopId, setShopId] = useState<any>();
  const [singleShopInfo, setSingleShopInfo] = useState({
    loading: false,
    data: null,
  });
  const [shopsOptions, setShopsOptions] = useState<any>({
    list: [],
    loading: false,
  });

  const fetchShopDetails = useCallback((getShopId) => {
    if (getShopId) {
      try {
        setSingleShopInfo({ loading: true, data: undefined });
        axios
          .get(
            `${process.env.REACT_APP_CATALOG_READER_API}/shop/details?shopId=${getShopId}`,
            {
              headers: {
                Authorization: `Bearer ${authenticateToken()}`,
                "Content-Type": "application/json",
              },
            }
          )
          .then((data) => {
            if (data.status === 200) {
              setSingleShopInfo({
                loading: false,
                data: data?.data?.shop,
              });
              dispatch({
                type: SET_SHOP_INFO,
                payload: {
                  shopInfo: {
                    id: data?.data?.shop?.id,
                    name: data?.data?.shop?.name,
                    type: data?.data?.shop?.type,
                    mobileNumber: data?.data?.shop?.mobileNumber,
                    logo: data?.data?.shop?.logo,
                    banner: data?.data?.shop?.banner,
                    rating: data?.data?.shop?.rating,
                    status: data?.data?.shop?.status,
                    hubId: data?.data?.shop?.hub?.id,
                    merchantId: data?.data?.shop?.merchantId,
                    deleted: data?.data?.shop?.deleted,
                  },
                },
              });
            } else {
              setSingleShopInfo({ loading: false, data: null });
              responseNotification(
                data.statusText || "something went wrong",
                "error"
              );
            }
          })
          .catch((err) => {
            setSingleShopInfo({ loading: false, data: null });

            console.log(err);
          });
      } catch (error) {
        setSingleShopInfo({ loading: false, data: null });

        console.log(error, "error");
      }
    }
  }, []);

  const getShopsOptions = useCallback(
    async (val?: string) => {
      setShopsOptions({ loading: true, list: [] });

      const res = await axios.get(
        `${process.env.REACT_APP_CATALOG_READER_API}/admin/shop?page=0&limit=20` +
          (val ? `&key=${val}` : ``) +
          (type ? `&type=${type}` : ``),
        {
          headers: {
            Authorization: `Bearer ${authenticateToken()}`,
          },
        }
      );
      setShopsOptions({
        loading: false,
        list: res?.data?.shops?.map((shop) => {
          return {
            value: shop?.id,
            label: shop?.name,
          };
        }),
      });
    },
    [type]
  );

  useEffect(() => {
    fetchShopDetails((route as any)?.shopId);
  }, [fetchShopDetails, route]);

  // const getCategoryOptions = useCallback(
  //   async (value) => {
  //     setCategoryData({ loading: true, list: null });
  //     const encodedUri = `${process.env.REACT_APP_CATALOG_READER_API}`;
  //     axios
  //       .get(
  //         `${encodedUri}/category/search?page=0&limit=20&isParent=true&type=${singleShopInfo?.data?.type}&key=${value}`,
  //         {
  //           headers: {
  //             Authorization: `Bearer ${authenticateToken()}`,
  //           },
  //         }
  //       )
  //       .then((res) => {
  //         setCategoryData({ loading: false, list: res.data });
  //       })
  //       .catch((err) => {
  //         setCategoryData({ loading: false, list: [] });
  //         console.error("Category: Error", err);
  //       });
  //   },
  //   [singleShopInfo?.data?.type]
  // );

  useEffect(() => {
    fetch(`${process.env.REACT_APP_CATALOG_WRITER_API}/shop/all-sync`, {
      headers: {
        "Content-type": "application/json",
      },
    })
      .then((response) => {
        if (response.ok) {
          //responseNotification("All Sync Successfully Update", "success");
        } else {
          console.error("Category: Error");
        }
      })
      .then((data) => {
        // responseNotification("All Sync Successfully Update", "success");
      })
      .catch((error) => {
        console.error("Category: Error");
      });
  }, []);

  const syncCategoryCampaignBrand = async () => {
    const data = await fetch(
      `${process.env.REACT_APP_CATALOG_WRITER_API}/shop/all-sync`,
      {
        headers: {
          "Content-type": "application/json",
        },
      }
    )
      .then((response) => {
        if (response.ok) {
          //responseNotification("All Sync Successfully Update", "success");
        } else {
          console.error("Category: Error");
        }
      })
      .then((data) => {
        // responseNotification("All Sync Successfully Update", "success");
      })
      .catch((error) => {
        console.error("Category: Error");
      });
  };
  useEffect(() => {
    syncCategoryCampaignBrand();
  }, []);

  const onConvertShopAsSupplier = async () => {
    if (shopId === singleShopInfo?.data?.id) {
      responseNotification(
        "You can't convert this SHOP into its own SUPPLIER!",
        "error"
      );
    } else {
      await fetch(
        `${process.env.REACT_APP_CATALOG_WRITER_API}/shop/converted-to-supplier`,
        {
          method: "PUT",
          headers: {
            Authorization: `Bearer ${authenticateToken()}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            needToConvertShopId: singleShopInfo?.data?.id,
            targetShopId: shopId,
          }),
        }
      )
        .then((res) => res.json())
        .then((res) => {
          if (res.statusCode === 200) {
            responseNotification(
              "Shop Converted as Supplier Successfully",
              "success"
            );
            history.push(`/shops`);
            setVisibleDrawer(!visibleDrawer);
            form.resetFields();
          } else if (res.status === 500) {
            responseNotification("Internal server error", "error");
          } else {
            responseNotification(res.message || "something wrong", "warning");
          }
        })
        .catch((err) => {
          responseNotification(`${"Internal server error"} ${err}`, "error");
          console.error("err", err);
        });
    }
  };

  // useEffect(() => {
  //   if (singleShopInfo?.data?.type) {
  //     getCategoryOptions("");
  //   }
  // }, [getCategoryOptions]);

  useEffect(() => {
    if (visibleDrawer) {
      getShopsOptions();
    }
  }, [getShopsOptions, visibleDrawer]);

  const fetchRef = useRef(0);
  const handleSearch = React.useMemo(() => {
    const loadOptions = (value: string, field: string) => {
      fetchRef.current += 1;
      const fetchId = fetchRef.current;

      if (fetchId !== fetchRef.current) {
        return;
      }
      if (value) {
        if (field === "shop") getShopsOptions(value);
      }
    };

    return debounce(loadOptions, 800);
  }, [getShopsOptions]);

  useEffect(() => {
    if (visible) {
      setSelectedShopForEdit(undefined);
    }
  }, [selectedShopForEdit]);

  useEffect(() => {
    setSelectedShopForEdit(undefined);
  }, [visible]);

  const showDrawer = () => {
    setVisibleDrawer(true);
  };

  const onClose = () => {
    setSelectedShopForEdit(null);
    fetchShopDetails((route as any)?.shopId);
    setVisibleDrawer(!visibleDrawer);
  };

  const shop = singleShopInfo?.data;

  return (
    <React.Fragment>
      <ShopLayout shopId={(route as any)?.shopId as string}>
        <div className="bg-white">
          <ShopHeader
            leftarea={"Shop Information"}
            rightarea={
              <div className="d-flex">
                <Button
                  type="dashed"
                  onClick={() => history.push(`/shops/${shop?.id}/edit`)}
                >
                  <EditOutlined /> Edit
                </Button>
                {/* <Popconfirm
                  title={
                    "Do you Confirm to sync  category campaign with brand?"
                  }
                  onConfirm={() => syncCategoryCampaignBrand()}
                  okText="Sync"
                >
                  <Button type="dashed" className="mr-2">
                    <SyncOutlined /> Sync All
                  </Button>
                </Popconfirm> */}
              </div>
            }
          />
          <div className="details-area">
            <div className="pt-4">
              <div className="inner-body">
                <div className="single">
                  <span className="info-name">Shop Name</span>
                  <span className="info-desc">{shop?.name}</span>
                </div>

                <div className="single">
                  <span className="info-name">Shop Slug</span>
                  <span className="info-desc">{shop?.slug}</span>
                </div>

                <div className="single">
                  <span className="info-name">Shop ID</span>
                  <span className="info-desc">{shop?.id}</span>
                </div>

                <div className="single">
                  <span className="info-name">Delivery Conition</span>
                  <span className="info-desc">
                    {shop?.isFreeDelivery === true
                      ? "Free Delivery"
                      : "Paid Delivery"}
                  </span>
                </div>

                <div className="single">
                  <span className="info-name">Base Delivery Charge</span>
                  <span className="info-desc">{shop?.baseDeliveryCharge}</span>
                </div>

                <div className="single">
                  <span className="info-name">Prepare Time</span>
                  <span className="info-desc">{shop?.prepareTime}</span>
                </div>

                <div className="single">
                  <span className="info-name">Mobile Number (Login)</span>
                  <span className="info-desc">
                    {shop?.mobileNumber?.split("+88")}
                  </span>
                </div>

                <div className="single">
                  <span className="info-name">Contact Number</span>
                  <span className="info-desc">
                    {shop?.contactNumber?.split("+88")}
                  </span>
                </div>

                <div className="single">
                  <span className="info-name">Email Address</span>
                  <span className="info-desc">{shop?.email}</span>
                </div>

                <div className="single">
                  <span className="info-name">Owner Id</span>
                  <span className="info-desc">{shop?.ownerId}</span>
                </div>

                <div className="single">
                  <span className="info-name">Address</span>
                  <span className="info-desc">{shop?.address}</span>
                </div>

                <div className="single">
                  <span className="info-name">Area</span>
                  <span className="info-desc">{shop?.area}</span>
                </div>

                <div className="single">
                  <span className="info-name">City</span>
                  <span className="info-desc">{shop?.city}</span>
                </div>

                <div className="single">
                  <span className="info-name">Country</span>
                  <span className="info-desc">{shop?.country}</span>
                </div>

                <div className="single">
                  <span className="info-name">Shop Type</span>
                  <span className="info-desc">
                    {shop?.type?.replace("_", " ")}
                  </span>
                </div>

                <div className="single">
                  <span className="info-name">Status</span>
                  <div className="info-desc">
                    <span
                      className={`radius-btn text-uppercase ${shop?.status?.toLowerCase()}-btn`}
                    >
                      {shop?.status?.toUpperCase() === "OPEN" ? (
                        <CheckOutlined className="mr-1" />
                      ) : shop?.status?.toUpperCase() === "BUSY" ? (
                        <WarningOutlined className="mr-1" />
                      ) : (
                        <CloseOutlined className="mr-1" />
                      )}
                      {shop?.status?.split("_").join(" ")}
                    </span>
                  </div>
                </div>

                <div className="single">
                  <span className="info-name">Rattings</span>
                  <span className="info-desc">
                    <Rate value={shop?.rating || 0} disabled />
                    <small className="ml-1">({shop?.numberOfRating})</small>
                  </span>
                </div>

                <div className="single">
                  <span className="info-name">Keywords</span>
                  <span className="info-desc">{shop?.keywords}</span>
                </div>

                <div className="single">
                  <span className="info-name">Description</span>
                  <span className="info-desc">{shop?.description}</span>
                </div>
              </div>

              <h6 className="mt-5 title" style={{ width: "98%" }}>
                Bank Details
              </h6>
              <div className="inner-body">
                <div className="single">
                  <span className="info-name">Account Name</span>
                  <span className="info-desc">
                    {shop?.bankInfo?.accountName}
                  </span>
                </div>

                <div className="single">
                  <span className="info-name">Account Number</span>
                  <span className="info-desc">
                    {shop?.bankInfo?.accountNumber}
                  </span>
                </div>

                <div className="single">
                  <span className="info-name">Bank Name</span>
                  <span className="info-desc">{shop?.bankInfo?.bankName}</span>
                </div>

                <div className="single">
                  <span className="info-name">Branch Name</span>
                  <span className="info-desc">
                    {shop?.bankInfo?.branchName}
                  </span>
                </div>

                {shop?.bankInfo?.routingNumber ? (
                  <div className="single">
                    <span className="info-name">Routing Number</span>
                    <span className="info-desc">
                      {shop?.bankInfo?.routingNumber}
                    </span>
                  </div>
                ) : undefined}

                {shop?.numberOfFollowers ? (
                  <div className="single">
                    <span className="info-name">Number Of Followers</span>
                    <span className="info-desc">{shop?.numberOfFollowers}</span>
                  </div>
                ) : undefined}

                {shop?.bankInfo?.swiftCode ? (
                  <div className="single">
                    <span className="info-name">Swift Code</span>
                    <span className="info-desc">
                      {shop?.bankInfo?.swiftCode}
                    </span>
                  </div>
                ) : undefined}
              </div>

              <h6 className="mt-5 title" style={{ width: "98%" }}>
                Hub Information
              </h6>
              <div className="inner-body">
                <div className="single">
                  <span className="info-name">Image</span>
                  <span className="info-desc">
                    <Avatar
                      size={100}
                      shape="square"
                      src={
                        <Image
                          src={shop?.hub?.image}
                          height={100}
                          width="auto"
                        />
                      }
                    />
                  </span>
                </div>

                <div className="single">
                  <span className="info-name">Hub Name</span>
                  <span className="info-desc">{shop?.hub?.name}</span>
                </div>

                <div className="single">
                  <span className="info-name">Type</span>
                  <span className="info-desc">{shop?.hub?.type}</span>
                </div>

                <div className="single">
                  <span className="info-name">Delivery Method</span>
                  <span className="info-desc">
                    {shop?.hub?.isFreeDelivery === true
                      ? "Free Delivery"
                      : "Paid Delivery"}
                  </span>
                </div>

                {shop?.hub?.minimumAmountForFreeDelivery ? (
                  <div className="single">
                    <span className="info-name">
                      Minimum Amount For Free Delivery
                    </span>
                    <span className="info-desc">
                      &#2547;{shop?.hub?.minimumAmountForFreeDelivery}
                    </span>
                  </div>
                ) : undefined}

                {shop?.hub?.baseDeliveryCharge ? (
                  <div className="single">
                    <span className="info-name">Base Delivery Charge</span>
                    <span className="info-desc">
                      &#2547;{shop?.hub?.baseDeliveryCharge}
                    </span>
                  </div>
                ) : undefined}
                {visible ? (
                  <QuestionCircleOutlined
                    onClick={() => {
                      setVisible(!visible);
                    }}
                  />
                ) : (
                  <QuestionCircleOutlined
                    onClick={() => {
                      setVisible(true);
                    }}
                  />
                )}
              </div>

              {shop?.merchantId ? (
                <>
                  <h6 className="mt-5 title" style={{ width: "98%" }}>
                    Merchant's Information
                  </h6>
                  <div className="inner-body">
                    <div className="single">
                      <span className="info-name">Image</span>
                      <span className="info-desc">
                        <Avatar
                          size={100}
                          shape="square"
                          src={
                            <Image src={shop?.merchant?.image} height={100} />
                          }
                        />
                      </span>
                    </div>

                    <div className="single">
                      <span className="info-name">Merchant Name</span>
                      <span className="info-desc">{shop?.merchant?.name}</span>
                    </div>

                    <div className="single">
                      <span className="info-name">Mobile Number</span>
                      <span className="info-desc">
                        {shop?.merchant?.mobileNumber}
                      </span>
                    </div>

                    <div className="single">
                      <span className="info-name">Email</span>
                      <span className="info-desc">{shop?.merchant?.email}</span>
                    </div>
                  </div>
                </>
              ) : undefined}

              {visible && (
                <div className="">
                  <h6 className="mt-5 title" style={{ width: "98%" }}>
                    Activity Logs
                  </h6>
                  <div className="inner-body">
                    <div className="single">
                      <span className="info-name">Created Date</span>
                      <span className="info-desc">
                        {moment(shop?.createdAt).format("lll")}
                      </span>
                    </div>

                    {shop?.createdBy?.name ? (
                      <div className="single">
                        <span className="info-name">Created By</span>
                        <span className="info-desc">
                          {shop?.createdBy?.name}
                        </span>
                      </div>
                    ) : undefined}

                    <div className="single">
                      <span className="info-name">Contact</span>
                      <span className="info-desc">
                        {shop?.createdBy?.mobileNumber ||
                          shop?.createdBy?.email}
                      </span>
                    </div>
                  </div>
                  {shop?.updatedAt ? (
                    <div className="inner-body mt-4">
                      <div className="single">
                        <span className="info-name">Updated Date</span>
                        <span className="info-desc">
                          {moment(shop?.updatedAt).format("lll")}
                        </span>
                      </div>

                      {shop?.updatedBy?.name ? (
                        <div className="single">
                          <span className="info-name">Updated By</span>
                          <span className="info-desc">
                            {shop?.updatedBy?.name}
                          </span>
                        </div>
                      ) : undefined}

                      {shop?.updatedBy?.mobileNumber ? (
                        <div className="single">
                          <span className="info-name">Contact</span>
                          <span className="info-desc">
                            {shop?.updatedBy?.mobileNumber ||
                              shop?.updatedBy?.email}
                          </span>
                        </div>
                      ) : undefined}
                    </div>
                  ) : undefined}
                </div>
              )}

              {/* <h6 className="mt-5 title" style={{ width: "98%" }}>
                Convert as Supplier
              </h6>
              <div className="inner-body">
                <div className="single">
                  <span className="info-name">Conver</span>
                  <span className="info-desc">
                    <Button
                      type="primary"
                      danger
                      size="large"
                      onClick={() => {
                        showDrawer();
                      }}
                    >
                      Convert as Supplier
                    </Button>
                  </span>
                </div>
              </div> */}

              <h4 className="mt-5 title" style={{ width: "98%" }}>
                Shop Location
              </h4>
              <MapBox
                draggable={false}
                coordinate={{
                  lat: shop?.location?.y,
                  lng: shop?.location?.x,
                }}
              />
            </div>
          </div>

          <Drawer
            title={selectedShopForEdit ? "Edit Shop" : ""}
            width={900}
            onClose={() => {
              setSelectedShopForEdit(null);
            }}
            visible={selectedShopForEdit}
            bodyStyle={{ paddingBottom: 80 }}
            footer={
              <div
                style={{
                  textAlign: "right",
                }}
              ></div>
            }
          >
            {selectedShopForEdit ? (
              <AddShop shopSlug={selectedShopForEdit} onCloseMethod={onClose} />
            ) : undefined}
          </Drawer>

          <Drawer
            title="CONVERT THIS SHOP AS SUPPLIER"
            placement="right"
            onClose={onClose}
            visible={visibleDrawer}
            width={450}
          >
            <div className="">
              <Form
                name="control-hooks"
                labelCol={{ span: 24 }}
                wrapperCol={{ span: 24 }}
                className="ant-form ant-form-vertical"
                onFinish={onConvertShopAsSupplier}
                form={form} // like ref
                layout="vertical"
                autoComplete="off"
              >
                <Alert
                  message="
                  Are you confirm to CONVERT this shop as a SUPPLIER in selected shop?"
                  type="warning"
                  banner
                  className="mb-4"
                />

                <Form.Item label="Select Shop" name="targetShopId">
                  <Select
                    showSearch
                    placeholder="Select Shop"
                    optionFilterProp="children"
                    onChange={(val) => setShopId(val)}
                    onSearch={(e) => handleSearch(e, "shop")}
                    filterOption={(input, option) =>
                      option.children
                        .toString()
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                    }
                  >
                    {shopsOptions.list.map((shop) => (
                      <Option value={shop?.value} key={shop?.value}>
                        {shop?.label}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>

                {/* <Button
                  type="primary"
                  danger
                  block
                  title="Convert as Supplier"
                  disabled={!shopId}
                  size="large"
                  htmlType="submit"
                  className="mr-3"
                >
                  <WarningFilled /> Convert as Supplier
                </Button> */}
              </Form>
            </div>
          </Drawer>
        </div>
      </ShopLayout>
    </React.Fragment>
  );
};
ShopDetails.propTypes = {
  match: PropTypes.object,
  params: PropTypes.object,
};
export default ShopDetails;
